import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=4ef0e63c&scoped=true"
import script from "./Gateway.vue?vue&type=script&lang=js"
export * from "./Gateway.vue?vue&type=script&lang=js"
import style0 from "./Gateway.vue?vue&type=style&index=0&id=4ef0e63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0e63c",
  null
  
)

export default component.exports